
export const talentTypeOfDocuments = [
    {
        name: 'Mon CV',
        label: 'CV',
        description: 'Scannez votre CV à plat pour un meilleur rendu. Le scan doit être recto/verso.',
        helpText: `(ajoutez ici votre CV dans le cas ou n'auriez pas complété votre profil)`,
        type: 'resume',
        maxFiles: 1,
    },
    {
        name: 'Votre RIB',
        label: 'RIB Bancaire',
        description: 'Scannez votre RIB à plat pour un meilleur rendu. Le scan doit être recto/verso.',
        helpText: '(obligatoire afin de pouvoir effectuer le virement de votre futur salaire)',
        type: 'rib',
    },
    {
        name: 'Ma Pièce d’identité',
        label: 'ID',
        helpText: '(Carte Nationale d’Identité ou Passeport)',
        description: 'Scannez vos documents à plat pour un meilleur rendu. Le scan doit être recto/verso.',
        type: 'identity',
    },
    {
        name: 'Carte vitale ',
        label: 'Carte vitale ou attestation d’affiliation à la sécurité sociale',
        description: 'Scannez vos documents à plat pour un meilleur rendu.',
        type: 'health_card',
    },
    {
        name: 'Diplôme',
        label: 'Scan du diplôme',
        description: 'Scannez vos documents à plat pour un meilleur rendu.',
        type: 'diploma',
    },
    {
        name: 'Jusitificatif de transport',
        label: 'Titre de transport',
        description: 'Document obligatoire dans le cadre de la prise en charge de vos frais de transport.',
        type: 'transport',
    },
    {
        name: 'Permis de conduire',
        label: 'Permis de conduire',
        helpText: '(Uniquement si l’entreprise le demande)',
        description:
            'Document non obligatoire, il peut être demandé par l’employeur. Scannez vos documents à plat pour un meilleur rendu. Le scan doit être recto/verso.',
        type: 'driving_license',
    },
    {
        name: 'Extrait de casier judiciaire',
        label: 'Extrait de casier judiciaire',
        helpText: '(https://casier-judiciaire.justice.gouv.fr/pages/accueil.xhtml)',
        description:
            'Document non obligatoire, il peut être demandé par l’employeur. Scannez vos documents à plat pour un meilleur rendu. Le scan doit être recto/verso.',
        type: 'criminal_record',
    },
];

export const talentGroupedDocuments = [
    {
        id: 'work_permit_group',
        name: 'Titre de séjour & permis de travail',
        description: 'Documents obligatoires pour les personnes étrangères',
        documents: [
            {
                name: 'Titre de séjour valide',
                label: 'Titre de séjour valide',
                helpText: '(uniquement pour les personnes étrangères)',
                description: 'Documents obligatoires pour les personnes étrangères.',
                type: 'work_permit',
                placeholder: 'Glissez déposez votre fichier (pdf, jpg, jpeg, png) pour télécharger votre titre de séjour ici. (max. 5MB)',
            },
            {
                name: 'Autorisation de travail',
                label: 'Autorisation de travail',
                helpText: '(uniquement pour les personnes étrangères)',
                description: 'Documents obligatoires pour les personnes étrangères.',
                type: 'work_authorization',
                placeholder: 'Glissez déposez votre fichier (pdf, jpg, jpeg, png) pour télécharger votre autorisation de travail ici. (max. 5MB)',
            },
        ],
    },
];
